import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";
import axios from "../api/axiosInstance";

export const requestNotificationPermission = async () => {

  try {

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {

      console.log("❌ Notification permission denied");

      return null;

    }

    const token = await getToken(messaging, {

      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,

    });

    if (!token) {

      console.log("⚠️ No FCM token");

      return null;

    }

    console.log("🔥 FCM Token:", token);

    // ✅ SEND CORRECT FIELD NAME
    await axios.post("/save-fcm-token/", {

      token: token,
      device: "web",

    });

    console.log("✅ FCM saved");

    return token;

  }

  catch (error) {

    console.error("🔥 FCM error:", error);

    return null;

  }

};